import { BehaviorSubject } from 'rxjs'

/**
 * The outcome of the most recent monitoring check. 'restricted' only ever follows a
 * successful locate (the location is verified, it's just in a restricted market) - it
 * can never co-occur with 'unverified', which is why this is one tri-state value rather
 * than two independent booleans.
 */
export type LocationStatus = 'verified' | 'unverified' | 'restricted'

export const locationStatus$ = new BehaviorSubject<LocationStatus>('unverified')
